import React from 'react';
import Stack from '@mui/material/Stack';

import {Spinner, type SpinnerProps} from './spinner';

/**
 * Props for the CenteredSpinner component
 * Extends SpinnerProps from the base Spinner component
 */
export type CenteredSpinnerProps = SpinnerProps;

/**
 * CenteredSpinner component that wraps the Spinner in a centered container
 * Useful for displaying a loading indicator centered in its parent container
 *
 * @param props - The component props (same as Spinner props)
 * @returns A spinner component centered in its container
 *
 * @example
 * ```tsx
 * <CenteredSpinner aria-label="Loading content" />
 * ```
 */
export const CenteredSpinner = (props: CenteredSpinnerProps) => {
    return (
        <Stack height="100%" width="100%" justifyContent="center" alignItems="center">
            <Spinner {...props} />
        </Stack>
    );
};
